import React, { useState } from 'react';
import { Input, Tag } from 'antd';
import { Card, TemplateGrid, TemplateCard } from './styled';
import { STARTER_TEMPLATES, STARTER_CATEGORIES } from './starterTemplates';

const { TextArea } = Input;

const StepBasics = ({ automation, update, onApplyTemplate, appliedTemplateKey }) => {
  const [category, setCategory] = useState('All');

  const visible = STARTER_TEMPLATES.filter(
    (t) => category === 'All' || t.category === category
  );

  return (
    <>
      <Card>
        <h3>Automation details</h3>
        <div className="desc">Give this automation a clear name your team will recognize.</div>
        <div className="row">
          <div className="full">
            <label>Name *</label>
            <Input
              size="large"
              value={automation.name}
              onChange={(e) => update({ name: e.target.value })}
              placeholder="e.g. Volunteer Welcome Sequence"
            />
          </div>
          <div className="full">
            <label>Description</label>
            <TextArea
              rows={2}
              value={automation.description}
              onChange={(e) => update({ description: e.target.value })}
              placeholder="What does this automation do?"
            />
          </div>
        </div>
      </Card>

      <Card>
        <h3>Start from a template</h3>
        <div className="desc">Pre-wired sequences you can customize. Or pick &quot;Blank&quot; to start from scratch.</div>
        <div style={{ marginBottom: 14, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {STARTER_CATEGORIES.map((c) => (
            <Tag.CheckableTag
              key={c}
              checked={category === c}
              onChange={() => setCategory(c)}
              style={{ padding: '4px 12px', borderRadius: 999, fontSize: 12 }}
            >
              {c}
            </Tag.CheckableTag>
          ))}
        </div>
        <TemplateGrid>
          {visible.map((t) => {
            const isSelected = appliedTemplateKey === t.key;
            return (
              <TemplateCard
                key={t.key}
                $selected={isSelected}
                onClick={() => onApplyTemplate(t)}
              >
                {isSelected && <div className="selected-badge">Selected</div>}
                <div className="icon">{t.icon}</div>
                <div className="ttl">{t.name}</div>
                <div className="desc">{t.description}</div>
                <div className="meta">{t.category}</div>
              </TemplateCard>
            );
          })}
        </TemplateGrid>
      </Card>
    </>
  );
};

export default StepBasics;
